import React from "react";
import TransactionView from "../../../transactions/view";
import { useParams } from "react-router-dom";
import { FilterEntityEnum } from "@propertelligent/client-api";

interface TransactionTabContentProps {
  result: any[];
  entityTypeId?: FilterEntityEnum;
  isContractor?: boolean;
  contractorPayeeAccountNames?: any;
  // Notifies the detail page's own header (Past Due/Income Due) to refetch after a transaction
  // delete -- mirrors PaymentTabContent's own onRefresh prop (bug/ui-bugfix-batch8 item 5
  // follow-up).
  onRefresh?: () => void;
}

const TransactionTabContent: React.FC<TransactionTabContentProps> = ({ result, entityTypeId, isContractor = false, contractorPayeeAccountNames, onRefresh }) => {

  const { id } = useParams();
  return (

    isContractor ? (
      <TransactionView
        isContractor={true}
        contractorPayeeAccountNames={contractorPayeeAccountNames}
        isEntity={true}
        entityId={id ? parseInt(id) : undefined}
        entityTypeId={entityTypeId}
        onRefresh={onRefresh}
      />
    ) : (
      <TransactionView
        isEntity={true}
        entityId={id ? parseInt(id) : undefined}
        entityTypeId={entityTypeId}
        onRefresh={onRefresh}
      />
    )

  )
}


export default TransactionTabContent;
